import { defineMessages, type MessageDescriptor } from 'react-intl';

const PLACEHOLDER_MESSAGES = defineMessages({
  text: {
    defaultMessage: 'Add text',
    description: 'Default placeholder for text input.',
    id: '7tnC6f9ag1/zG/vh',
  },
  password: {
    defaultMessage: 'Add password',
    description: 'Default placeholder for password input.',
    id: 'B3Rj3sRBMMfDBuzK',
  },
  email: {
    defaultMessage: 'Add email',
    description: 'Default placeholder for email input.',
    id: 'xcSpnebtYoA/jEJY',
  },
  url: {
    defaultMessage: 'Add URL',
    description: 'Default placeholder for URL input.',
    id: 'IK8qCfDGg9HgIHQC',
  },
  tel: {
    defaultMessage: 'Add phone number',
    description: 'Default placeholder for phone number input.',
    id: 'xjwKUTJHlmtA/V/n',
  },
  search: {
    defaultMessage: 'Search',
    description: 'Default placeholder for search input.',
    id: 'Fr3cNB5JDQGaGwae',
  },
});

function isPlaceholderType(
  type: string | undefined,
): type is keyof typeof PLACEHOLDER_MESSAGES {
  return type !== undefined && type in PLACEHOLDER_MESSAGES;
}

export function getPlaceholderMessage(
  type: string | undefined,
): MessageDescriptor {
  if (isPlaceholderType(type)) {
    return PLACEHOLDER_MESSAGES[type];
  }
  return PLACEHOLDER_MESSAGES.text;
}
